export default function Conexion() {
    const apiUrl = "https://qr.edgebol.com";
    return {
        apiUrl
    }
}
